import React from 'react';

const FeatureList = () => {
  return (
    <div className="list-section pt-80 pb-80">
      <div className="container">
        <div className="row">
          {/* Reasonable Prices */}
          <div className="col-lg-4 col-md-6 mb-4 mb-lg-0">
            <div className="list-box d-flex align-items-center">
              <div className="list-icon">
                <i className="fas fa-tags"></i> {/* Price Tag Icon */}
              </div>
              <div className="content">
                <h3>Reasonable Prices</h3>
              </div>
            </div>
          </div>

          {/* Customer Support */}
          <div className="col-lg-4 col-md-6 mb-4 mb-lg-0">
            <div className="list-box d-flex align-items-center">
              <div className="list-icon">
                <i className="fas fa-headset"></i> {/* Headset Icon */}
              </div>
              <div className="content">
                <h3>Customer Support 24/7</h3>
              </div>
            </div>
          </div>

          {/* Quick Order */}
          <div className="col-lg-4 col-md-6">
            <div className="list-box d-flex justify-content-start align-items-center">
              <div className="list-icon">
                <i className="fas fa-clock"></i> {/* Clock Icon */}
              </div>
              <div className="content">
                <h3>Quick Order</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeatureList;
